<template>
  <div class="clearfix" style="width: 1200px;margin:20px auto;">
    <!-- 左侧导航 -->
    <nav class="fl">
      <div class="title">中国—中东欧国家贸易指数</div>
      <ul class="menus">
        <li class="menu" v-for="item in navData" :key="item.indicatorid">
          <router-link
            v-if="item.name !== '贸易结构'"
            class="first-menu"
            :class="{hover:indicatorId == item.indicatorid}"
            :to="{path:'/exp/msr/zdo',query:{id:item.indicatorid}}"
          >{{item.name}}</router-link>

          <a
            v-else
            href="javascript:;"
            class="first-menu"
            :class="{hover:indicatorId == '19' || indicatorId == '20'}"
          >{{item.name}}</a>
          <ul class="first-menu-ul" v-if="item.menuList">
            <li class="first-menu-li" v-for="ele in item.menuList" :key="ele.indicatorid">
              <router-link
                :to="{path:'/exp/msr/zdo',query:{id:ele.indicatorid}}"
                :class="{hover:indicatorId == ele.indicatorid}"
              >{{ele.name}}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <!-- 右侧内容 -->
    <div class="fr main">
      <!-- 选择框 -->
      <div class="select_box">
        <div class="intro" @click="dialogTableVisible = true">指数说明</div>
        <el-dialog title="指数说明" :visible.sync="dialogTableVisible">
          <p>中国一中东欧国家贸易指数（包含贸易规模指标、贸易结构指标和贸易对象指标）是在海关总署统计分析司的授权和指导下，宁波海关联合宁波航运交易所编制，2021年6月在“第五届中国一中东欧国家海关检验检疫合作对话会”上正式发布。中国一中东欧国家贸易指数直观展示了当前中国对中东欧国家进出口贸易发展水平和未来发展前景，是中国对中东欧国家贸易发展状况的晴雨表和风向标。</p>
        </el-dialog>
        <!-- 进出口 -->
        <ul class="clearfix">
          <li class="fl">
            <strong>进出口类型：</strong>
          </li>
          <el-radio-group
            class="fl"
            v-if="indicatorId == '16'"
            v-model="tradeScaleOption"
            @change="handleCheckedChange"
          >
            <el-radio v-for="item in options" :key="item.id" :label="item.label">{{item.label}}</el-radio>
          </el-radio-group>

          <el-radio-group
            class="fl"
            v-if="indicatorId == '19'"
            v-model="productOption"
            @change="handleProductChange"
          >
            <el-radio
              v-for="item in options.slice(1)"
              :key="item.id"
              :label="item.label"
            >{{item.label}}</el-radio>
          </el-radio-group>

          <el-checkbox-group
            class="fl"
            v-if="indicatorId == '18' || indicatorId == '20'"
            v-model="tradeObjectOption"
          >
            <el-checkbox v-for="item in options" :key="item.id" :label="item.label">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </ul>
        <!-- 指标类型 -->
        <ul class="clearfix">
          <li class="fl">
            <strong>指标类型：</strong>
          </li>
          <el-checkbox-group
            class="fl"
            v-if="indicatorId == '16'"
            v-model="tradeScaleIndicator"
            :disabled="indicatorDisabled"
          >
            <el-checkbox
              v-for="item in tradeScaleIndicatorStyle"
              :key="item.id"
              :label="item.name"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
          <el-checkbox-group class="fl" v-if="indicatorId == '19'" v-model="productIndicator">
            <el-checkbox
              v-for="item in productIndicatorStyle"
              :key="item.id"
              :label="item.name"
            >{{item.name}}</el-checkbox>
            <el-checkbox label="劳动密集型产品" :disabled="productIndicatorDisabled"></el-checkbox>
          </el-checkbox-group>
          <el-radio-group
            class="fl"
            v-if="indicatorId == '20'"
            v-model="transportIndicator"
            style="margin-left: 14px;text-align: left;width: 700px;"
          >
            <el-radio
              v-for="item in transportIndicatorStyle"
              :key="item.id"
              :label="item.name"
            >{{item.name}}</el-radio>
          </el-radio-group>
          <el-radio-group
            class="fl country"
            v-if="indicatorId == '18'"
            v-model="tradeObjectIndicator"
            style="margin-left: 14px;text-align: left;width: 700px;"
          >
            <el-radio
              v-for="item in tradeObjectIndicatorStyle"
              :key="item.id"
              :label="item.name"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </ul>
        <!-- 时间 -->
        <div class="clearfix" style="margin: 32px 0;">
          <el-date-picker
            class="fl"
            v-model="startMonth"
            type="month"
            placeholder="开始日期"
            value-format="yyyy-MM"
            @change="startMonthChange"
            :picker-options="startPickerOptions"
          ></el-date-picker>
          <span class="fl" style="line-height: 31px;padding: 0 8px;">至</span>
          <el-date-picker
            class="fl"
            v-model="endMonth"
            type="month"
            placeholder="结束日期"
            value-format="yyyy-MM"
            @change="endMonthChange"
            :picker-options="endPickerOptions"
          ></el-date-picker>
          <div class="button fl">
            <a href="javascript:;" class="btn-blue1" @click="zdoSearch">查询</a>
          </div>
        </div>
      </div>
      <!-- 折线图 -->
      <div class="mapbox">
        <div class="bj_white2 home">
          <div class="table_p">
            <div ref="msrLine" id="msrLine" style="margin:0 auto; width:95%; height:100%;"></div>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table">
        <!-- 表 -->
        <my-table :col="col" :data="data"></my-table>
      </div>
    </div>
  </div>
</template>

<script>
import MyTable from "@/components/MyTable";
import dtChart from "@/components/DrawEcharts";
import { api } from "@/require/api";
export default {
  components: {
    MyTable,
    dtChart
  },
  data() {
    return {
      navData: [],
      indicatorId: "",
      // 进出口
      tradeScaleOption: "",
      productOption: "",
      tradeObjectOption: [],
      options: [
        { id: 11, label: "进出口" },
        { id: 12, label: "进口" },
        { id: 13, label: "出口" }
      ],
      // 指标类型
      tradeScaleIndicator: [],
      tradeScaleIndicatorStyle: [
        { id: 1, name: "价值指数" },
        { id: 2, name: "价格指数" },
        { id: 3, name: "数量指数" }
      ],
      productIndicator: [],
      productIndicatorStyle: [
        { id: 1, name: "机电产品" },
        { id: 2, name: "农产品" }
      ],
      transportIndicator: "",
      transportIndicatorStyle: [
        { id: 1, name: "水路运输" },
        { id: 2, name: "铁路运输" },
        { id: 3, name: "航空运输" }
      ],
      tradeObjectIndicator: "",
      tradeObjectIndicatorStyle: [
        { id: 1, name: "阿尔巴尼亚" },
        { id: 2, name: "爱沙尼亚" },
        { id: 3, name: "保加利亚" },
        { id: 4, name: "北马其顿" },
        { id: 5, name: "波黑" },
        { id: 6, name: "波兰" },
        { id: 7, name: "黑山" },
        { id: 8, name: "捷克" },
        { id: 9, name: "克罗地亚" },
        { id: 10, name: "拉脱维亚" },
        { id: 11, name: "罗马尼亚" },
        { id: 12, name: "塞尔维亚" },
        { id: 13, name: "斯洛伐克" },
        { id: 14, name: "斯洛文尼亚" },
        { id: 15, name: "希腊" },
        { id: 16, name: "匈牙利" }
      ],
      indicatorDisabled: false,
      productIndicatorDisabled: false,
      // 时间
      startMonth: "",
      endMonth: "",
      startPickerOptions: {
        disabledDate: time => {
          if (time.getTime() > Date.now()) {
            return true;
          }
        }
      },
      endPickerOptions: {
        disabledDate: time => {
          if (time.getTime() > Date.now()) {
            return true;
          }
        }
      },
      // 表格
      col: [],
      data: [],
      dialogTableVisible: false
    };
  },
  created() {
    this.getNav();
  },
  methods: {
    // 左侧导航
    async getNav() {
      const { code, data } = await api.get("/NewMSRIController/get17HoverMenu");
      if (code === 0) {
        this.navData = data;
      }
    },
    // 【选择框】
    handleCheckedChange(val) {
      if (val === "进出口") {
        this.indicatorDisabled = true;
        this.tradeScaleIndicator = ["综合指数"];
      } else {
        this.indicatorDisabled = false;
        if (this.tradeScaleIndicator.includes("综合指数")) {
          this.tradeScaleIndicator.splice(
            this.tradeScaleIndicator.indexOf("综合指数"),
            1
          );
        }
      }
    },
    handleProductChange(val) {
      if (val === "进口") {
        this.productIndicatorDisabled = true;
        if (this.productIndicator.includes("劳动密集型产品")) {
          this.productIndicator.splice(
            this.productIndicator.indexOf("劳动密集型产品"),
            1
          );
        }
      } else {
        this.productIndicatorDisabled = false;
      }
    },
    // 【选择框---时间选择框】
    startMonthChange(val) {
      this.endMonth = "";
      if (val) {
        // 获取当前日期往前6个月的月份
        let currentMonth = new Date().getMonth() + 1;
        let currentYear = new Date().getFullYear();
        let startTime = "";
        Number(val.slice(5)) + 6 > 12
          ? (startTime =
              Number(val.slice(0, 4)) + 1 + "-" + (Number(val.slice(5)) - 6))
          : (startTime =
              Number(val.slice(0, 4)) + "-" + (Number(val.slice(5)) + 6));

        if (startTime.length === 6) {
          startTime.replace("-", "-0");
        }
        this.endPickerOptions.disabledDate = time => {
          if (new Date(startTime).getTime() > Date.now()) {
            return (
              time.getTime() > Date.now() ||
              time.getTime() <= new Date(val).getTime()
            );
          } else {
            return (
              time.getTime() >= new Date(startTime).getTime() ||
              time.getTime() <= new Date(val).getTime()
            );
          }
        };
      }
    },
    endMonthChange() {
      if (!this.startMonth) {
        this.endMonth = "";
        this.$message({
          message: "请先选择开始日期",
          type: "warning"
        });
      }
    },
    // 默认的数据
    async getDefaultLine() {
      const { code, data } = await api.get(
        "/NewMSRIController/getZDODefLineChartData",
        {
          indicatorId: this.indicatorId
        }
      );
      let legendData = [];
      let xAxisData = [];
      let yAxisData = [];
      if (code === 0) {
        legendData = data.chartKeys;
        xAxisData = data.xvalues;
        yAxisData = data.series;
        this.drawline(legendData, xAxisData, yAxisData);
      }
    },
    async getdefaultTable() {
      this.col = [];
      this.data = [];
      const { code, data } = await api.get(
        "/NewMSRIController/getZDODefExcelData",
        {
          indicatorId: this.indicatorId
        }
      );
      if (code === 0) {
        this.col = data.col;
        this.data = data.data;
      }
    },
    // 统一绘制折线图
    drawline(legendData, xAxisData, yAxisData) {
      let msrLine = this.$echarts.init(document.getElementById("msrLine"));
      msrLine.clear();
      msrLine.setOption({
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#9ca7b0",
              option: 0.3
            }
          }
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData
        },
        yAxis: {
          type: "value"
        },
        series: yAxisData
      });
      window.onresize = function() {
        msrLine.resize();
      };
    },
    // 查询
    zdoSearch() {
      // 获取当前日期往前6个月的月份
      let currentMonth = new Date().getMonth() + 1;
      let currentYear = new Date().getFullYear();
      let startTime = "";
      currentMonth - 6 >= 0
        ? (startTime = currentYear + "-" + (currentMonth - 6 + 1))
        : (startTime = currentYear - 1 + "-" + (currentMonth - 6 + 13));
      // 判断选项是否为空，空赋初始值
      this.startMonth && this.endMonth
        ? this.startMonth
        : (this.startMonth = startTime);
      this.startMonth && this.endMonth
        ? this.endMonth
        : (this.endMonth =
            new Date().getFullYear() + "-" + (new Date().getMonth() + 1));

      if (this.indicatorId == "16") {
        // 贸易规模
        this.tradeScaleOption
          ? this.tradeScaleOption
          : (this.tradeScaleOption = "出口");
        this.tradeScaleIndicator.join(",")
          ? this.tradeScaleIndicator.join(",")
          : (this.tradeScaleIndicator = ["价值指数"]);
        this.getTable(
          this.tradeScaleOption,
          this.tradeScaleIndicator.join(","),
          "贸易规模"
        );
        this.getLine(this.tradeScaleOption, this.tradeScaleIndicator.join(","));
      } else if (this.indicatorId == "19") {
        //   商品结构
        this.productOption ? this.productOption : (this.productOption = "出口");
        this.productIndicator.join(",")
          ? this.productIndicator.join(",")
          : (this.productIndicator = ["机电产品"]);
        this.getTable(
          this.productOption,
          this.productIndicator.join(","),
          "商品结构"
        );
        this.getLine(this.productOption, this.productIndicator.join(","));
      } else if (this.indicatorId == "20") {
        //   运输方式
        this.tradeObjectOption.join(",")
          ? this.tradeObjectOption.join(",")
          : (this.tradeObjectOption = ["出口"]);
        this.transportIndicator
          ? this.transportIndicator
          : (this.transportIndicator = "水路运输");
        this.getTable(
          this.tradeObjectOption.join(","),
          this.transportIndicator,
          "运输方式"
        );
        this.getLine(this.tradeObjectOption.join(","), this.transportIndicator);
      } else if (this.indicatorId == "18") {
        //   贸易对象
        this.tradeObjectOption.join(",")
          ? this.tradeObjectOption.join(",")
          : (this.tradeObjectOption = ["出口"]);
        this.tradeObjectIndicator
          ? this.tradeObjectIndicator
          : (this.tradeObjectIndicator = "阿尔巴尼亚");
        this.getTable(
          this.tradeObjectOption.join(","),
          this.tradeObjectIndicator,
          "贸易对象"
        );
        this.getLine(
          this.tradeObjectOption.join(","),
          this.tradeObjectIndicator
        );
      }
    },
    async getTable(ioreNames, indicatorNames, titleName) {
      this.col = [];
      this.data = [];
      const { code, data } = await api.get(
        "/NewMSRIController/getZDOSelectiveTable",
        {
          ioreNames: ioreNames,
          indicatorNames: indicatorNames,
          startTid:
            this.startMonth.length === 6
              ? this.startMonth.replace("-", "0")
              : this.startMonth.replace("-", ""),
          endTid:
            this.endMonth.length === 6
              ? this.endMonth.replace("-", "0")
              : this.endMonth.replace("-", ""),
          titleName: titleName
        }
      );
      if (code === 0) {
        this.col = data.col;
        this.data = data.data;
      }
    },
    async getLine(ioreNames, indicatorNames) {
      const { code, data } = await api.get(
        "/NewMSRIController/showTotalDiagramSelective",
        {
          ioreNames: ioreNames,
          indicatorNames: indicatorNames,
          begin:
            this.startMonth.length === 6
              ? this.startMonth.replace("-", "0")
              : this.startMonth.replace("-", ""),
          end:
            this.endMonth.length === 6
              ? this.endMonth.replace("-", "0")
              : this.endMonth.replace("-", "")
        }
      );
      let legendData = [];
      let xAxisData = [];
      let yAxisData = [];
      if (code === 0) {
        legendData = data.chartKeys;
        xAxisData = data.xvalues;
        yAxisData = data.series;
        this.drawline(legendData, xAxisData, yAxisData);
      }
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.indicatorId = to.query.id;
        // 清空数据
        (this.tradeScaleOption = ""),
          (this.productOption = ""),
          (this.tradeObjectOption = []),
          (this.tradeScaleIndicator = []),
          (this.productIndicator = []),
          (this.transportIndicator = ""),
          (this.tradeObjectIndicator = ""),
          (this.startMonth = ""),
          (this.endMonth = ""),
          this.getDefaultLine();
        this.getdefaultTable();
      },
      immediate: true
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/exp.less";
nav {
  width: 220px;
  .title {
    background: #4996dd;
    line-height: 50px;
    font-size: 16px;
    color: #fff;
  }
  .menus {
    border: #ddd 1px solid;
    background: #fff;
    padding: 5px 20px 10px;
    .menu {
      .first-menu {
        display: block;
        font-size: 15px;
        line-height: 45px;
        border-bottom: 1px solid #ddd;
        // color: #4996dd;
        color: #333;
        font-weight: 700;
      }
      .first-menu-ul {
        .first-menu-li {
          a {
            color: #666;
            line-height: 24px;
            padding-left: 26px;
            position: relative;
            &::after {
              content: "";
              display: block;
              position: absolute;
              height: 4px;
              width: 4px;
              border-radius: 50%;
              background: #666;
              top: 8px;
              left: 14px;
            }
          }
        }
        .first-menu-li:nth-child(2) {
          border-bottom: 1px solid #ddd;
          padding-bottom: 18px;
        }
      }
    }
    .menu:nth-child(2) .first-menu {
      border-bottom: 0;
    }
  }
  .hover {
    color: #4996dd !important;
    &::after {
      background: #4996dd !important;
    }
  }
}
.main {
  width: 920px;
  .select_box {
    position: relative;
    padding-left: 100px;
    .intro {
      position: absolute;
      right: 0;
      font-size: 16px;
      color: #3a94de;
      font-weight: 700;
    }
    ul {
      margin: 20px 0;
    }
    .el-range-editor.el-input__inner {
      margin-top: 0px;
      margin-left: 0px;
    }
    /deep/.el-date-editor .el-range-separator {
      padding: 0;
    }
    /deep/.el-input__icon,
    /deep/.el-input__inner {
      height: 31px;
      line-height: 31px;
    }
    .country {
      /deep/.el-radio {
        margin-bottom: 12px;
      }
    }
  }
  .mapbox {
    padding: 0;
    margin-bottom: 40px;
  }
  /deep/.el-dialog__title {
    color: #3a94de;
    font-size: 20px;
  }
  .el-dialog__body {
    p {
      line-height: 34px;
      font-size: 18px;
      text-indent: 2em;
      text-align: justify;
    }
  }
}
</style>